import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query($order: [SchoolsFindOrder!], $paging: PagingQuery, $where: SchoolsFindFilter) {\n    findSchools(\n      order: $order,\n      paging: $paging,\n      where: $where,\n    ) {\n      schools {\n        id\n        name\n      } \n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query($orderId: Int!) {\n    findOrder(\n      orderId: $orderId\n    ) {\n      mailingAddress\n      orderNumber\n      schoolId\n      area {\n        cityCode\n        createdAt\n        id\n        ing\n        lat\n        levelType\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        mergerName\n        name\n        parentId\n        pinyin\n        shortName\n        updatedAt\n        zipCode\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($mailingAddress: String!,$orderId: Int!, $schoolId: Int!, $areaId: Int!) {\n    updateOrderAddress(\n      mailingAddress: $mailingAddress\n      orderId: $orderId\n      schoolId: $schoolId\n      areaId: $areaId\n    )\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var updateOrderAddress = gql(_templateObject());
export var findOrder = gql(_templateObject2());
export var findSchools = gql(_templateObject3());